import "../styles/nosotros.css";

export default function Nosotros() {
  return (
    <div className="nosotros-container">

      <section className="nosotros-hero">
        <h1>SOBRE CENTRO MILLENNIALS (CEM)</h1>
        <p>
          Formación online enfocada en el desarrollo profesional,
          tecnológico y humano.
        </p>
      </section>

      <section className="nosotros-bloque">
        <h2>Quiénes somos</h2>
        <p>
        Somos una institución chilena de formación profesional, creada con el propósito de acercar el conocimiento a personas de todo el mundo. Nacimos en Chile, 
        pero creemos firmemente que el aprendizaje no tiene fronteras.
        <br></br>
        Nuestro enfoque está en entregar educación práctica, actualizada y accesible, pensada 
        para quienes buscan crecer profesionalmente, reinventarse o adquirir nuevas habilidades 
        en un entorno laboral cada vez más globalizado.
        </p>
      </section>

      <section className="nosotros-bloque">
        <h2>Nuestra misión</h2>
        <p>
        Impulsar el crecimiento profesional continuo, permitiendo que personas de cualquier
         país puedan aprender, capacitarse y avanzar en su carrera desde cualquier lugar 
         del mundo, sin importar su ubicación geográfica.
         <br></br>
         Creemos que la educación debe adaptarse a las personas y no al revés.
        </p>
      </section>

      <section className="nosotros-bloque">
        <h2>Nuestra visión</h2>
        <p>
        Ser una institución de referencia en formación online, reconocida por su calidad 
        académica, cercanía con los estudiantes y capacidad de conectar a personas de 
        distintos países a través del aprendizaje.
        <br></br>
        Buscamos construir una comunidad internacional de estudiantes y profesionales que 
        compartan el mismo objetivo: seguir aprendiendo toda la vida.
        </p>
      </section>

      <section className="nosotros-bloque">
        <h2>Nuestro compromiso</h2>
        <ul>
          <li>🌎 Formación accesible a nivel internacional</li>
          <li>🇨🇱 Raíces chilenas, visión global</li>
          <li>📚 Contenidos actualizados y orientados al mundo real</li>
          <li>👨‍🏫 Profesores con experiencia práctica con postgrados y magisters</li>
          <li>🚀 Enfoque en desarrollo profesional y empleabilidad</li>
        </ul>
      </section>

      <section className="nosotros-bloque">
        <h2>Nuestra visión</h2>
        <p>
        En un mundo en constante cambio, creemos que seguir aprendiendo es la clave 
        para crecer.
        <br></br>
        Por eso, ofrecemos cursos diseñados para acompañarte en cada etapa de 
        tu desarrollo profesional, estés donde estés.
        </p>
      </section>

    </div>
  );
}
